import {FC, Fragment} from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getUser, getUserEarnedAchievements} from "modules/selectors";
import {useIsMobile} from "modules/utils";
import {Avatar, Badge} from "components";
import {AvatarWrapper, Name, Wrapper} from "./common";

const Desc = styled.div`
	font-size: 14px;
	font-weight: 500;
	line-height: 160%;

	@media (min-width: 769px) {
		font-size: 16px;
	}
`;

const Badges = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 12px;
	margin-top: 5px;
`;

export const ProfileWithBadges: FC = () => {
	const {t} = useTranslation();
	const {isMobile} = useIsMobile();
	const user = useSelector(getUser)!;
	const achievements = useSelector(getUserEarnedAchievements);
	const size = isMobile ? "40px" : "55px";

	return (
		<Wrapper>
			<AvatarWrapper>
				<Avatar />
			</AvatarWrapper>

			<div>
				<Name>
					{user.firstName} {user.lastName}
				</Name>

				{Boolean(achievements.length) && (
					<Fragment>
						<Desc>{t("profile.my_badges")}</Desc>

						<Badges>
							{achievements.slice(-3).map((achievement, i) => (
								<Badge
									key={`${i}`}
									achievement={achievement}
									height={size}
									width={size}
								/>
							))}
						</Badges>
					</Fragment>
				)}
			</div>
		</Wrapper>
	);
};
